import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Pagination({ page, limit, total, onPageChange }) {
  const { t } = useLanguage();
  const totalPages = Math.ceil(total / limit) || 1;

  return (
    <div className="pagination">
      <span>
        {t('common.showing')} {Math.min((page - 1) * limit + 1, total)}-{Math.min(page * limit, total)} {t('common.of')} {total}
      </span>
      <div className="pagination-buttons">
        <button
          className="pagination-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          {t('common.previous')}
        </button>
        {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
          let p;
          if (totalPages <= 5) {
            p = i + 1;
          } else if (page <= 3) {
            p = i + 1;
          } else if (page >= totalPages - 2) {
            p = totalPages - 4 + i;
          } else {
            p = page - 2 + i;
          }
          return (
            <button
              key={p}
              className={`pagination-btn ${p === page ? 'active' : ''}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          );
        })}
        <button
          className="pagination-btn"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          {t('common.next')}
        </button>
      </div>
    </div>
  );
}
